import React from 'react';
import { Stack } from '@mui/material';
import { useParams } from 'react-router-dom';
import { DocumentsTabFallback } from './DocumentsTabFallback';
import { DocumentsCard } from './DocumentsCard';
import { useDocumentsTabDataFetch } from 'modules/customers/hooks/useDocumentsTabDataFetch';

export const CustomerDetailsDocumentsTab = () => {
  const { id: customerAccountId } = useParams<{ id: string }>();
  const { isLoading, documentsTableData } = useDocumentsTabDataFetch(customerAccountId);

  if (isLoading) {
    return <DocumentsTabFallback />;
  }

  return (
    <Stack gap={1}>
      <DocumentsCard documentsTableData={documentsTableData} />
    </Stack>
  );
};
